export default function closeNode(node_url) {
    return fetch(`${node_url}/keycode/113/d`);
}
